const topicGroupColorMap = {
  A: '#DE4B9B',
  B: '#00B3B3',
  C: '#8873FF',
  D: '#2894D1',
  E: '#F1B334',
  F: '#FF986C',
  G: '#64BEFF',
  H: '#5873FF',
  I: '#FF6694',
  J: '#27B772',
  K: '#CF866F',
  L: '#FF932F',
  M: '#DE4B9B',
  N: '#00B3B3',
  O: '#8873FF',
  P: '#2894D1',
  Q: '#F1B334',
  R: '#FF986C',
  S: '#64BEFF',
  T: '#5873FF',
  U: '#FF6694',
  V: '#27B772',
  W: '#CF866F',
  X: '#FF932F',
  Y: '#DE4B9B',
  Z: '#00B3B3'
};

const getTopicGroupAssetObj = (title) => {
  if (!title) return {};

  const alphabet = title.charAt(0) || 'A';
  return {
    color: topicGroupColorMap[alphabet],
    icon: `subjects-icons/Type-${alphabet}.svg`
  };
};

export default getTopicGroupAssetObj;
